import clamp from 'clamp-js';
import Flickity from 'flickity';
import { initCenterFocusCarousel } from './centerFocusCarousel';
import { getRTL } from './_utils';

const baseClass = 'AnimatedCardCarouselBackground';
const activeClass = `${baseClass}-BackgroundImage--active`;

const selectors = {
	base: `.${baseClass}`,
	centerFocusCarousel: '.CenterFocusCarousel',
	flickity: `.CenterFocusCarousel-container--desktop .CenterFocusCarousel--list`,
	background: `.${baseClass}-BackgroundImage`,
	activeBackground: `.${activeClass}`,
	description: `.${baseClass}-Card--active .${baseClass}-Card-text`,
	card: `.${baseClass}-Card`,
	cardActiveSection: `.${baseClass}-Card--active`,
	cardInactiveSection: `.${baseClass}-Card--inactive`,
	cardCTA: `.${baseClass}-Card-CTA`,
};

const setupBackgroundChange = $container => {
	const $flickityDesktop = $container.find(selectors.flickity);
	$flickityDesktop.on('ready.flickity', () => {
		const flickityInstance = Flickity.data($flickityDesktop[0]);
		const $allActive = $container.find(selectors.cardActiveSection);
		const $allInactive = $container.find(selectors.cardInactiveSection);
		const $allCTAs = $container.find(selectors.cardCTA);
		flickityInstance.on('change', index => {
			$allActive.attr('aria-hidden', true);
			$allInactive.attr('aria-hidden', '');
			$allCTAs.attr('tabindex', -1);
			const $activeSlide = $(flickityInstance.selectedElement);
			$activeSlide.find(selectors.cardActiveSection).attr('aria-hidden', '');
			$activeSlide.find(selectors.cardInactiveSection).attr('aria-hidden', true);
			$activeSlide.find(selectors.cardCTA).attr('tabindex', 0);
			const $activeBackground = $container.find(selectors.activeBackground);
			const id = $activeSlide.data('bgImageId');
			const $nextBackground = $container.find(`.${id}`);
			$activeBackground.removeClass(activeClass);
			$nextBackground.addClass(activeClass);
		});
	});
};

const setupClamp = $container => {
	$container.find(selectors.description).each((i, description) => {
		clamp(description, { clamp: 4, useNativeClamp: true });
	});

	//bullet point card clamping
	let $bulletInactiveCards = $container.find(
		'.BulletPointCard .AnimatedCardCarouselBackground-Card--inactive'
	);

	if ($bulletInactiveCards.length > 0) {
		let tallestHeight = 0;
		const $cardActiveSections = $container.find(selectors.cardActiveSection);

		$cardActiveSections.each(function (index) {
			const $activeSection = $(this);
			let $children = $activeSection.children('div');
			let childrenHeight = 0;
			$children.each((i, child) => {
				childrenHeight += $(child).outerHeight();
			});
			tallestHeight = Math.max(childrenHeight, tallestHeight);
		});

		$bulletInactiveCards.each((index, card) => {
			let $items = $(card).find('.BulletedList-item');
			let $lastItem = $items.last();
			let $heading = $(card).find('.Heading.BulletedList-heading');
			let roomLeft = tallestHeight - ($heading.height() + 120 + 36 + 46);
			const parentHeight = $items.parent().height();
			if (parentHeight > 0 && roomLeft < parentHeight) {
				clamp($lastItem[0], { clamp: $lastItem.height() / 27 - 1, useNativeClamp: false });
			}
		});
	}
};

export default function initACCBackground() {
	$(selectors.base).each((i, container) => {
		const $container = $(container);
		setupBackgroundChange($container);
		setupClamp($container);

		const getTallestHeight = () => {
			let tallestHeight = 0;
			const $cardActiveSections = $container.find(selectors.cardActiveSection);

			$cardActiveSections.each(function (index) {
				const $activeSection = $(this);
				let $children = $activeSection.children('div');
				let childrenHeight = 0;
				$children.each((i, child) => {
					childrenHeight += $(child).outerHeight();
				});
				tallestHeight = Math.max(childrenHeight, tallestHeight);
			});

			$cardActiveSections.css('height', tallestHeight);
			return tallestHeight;
		};

		const slideConfig = $container.data('slideConfig') || {
			activeWidth: 400,
			inactiveWidth: 350,
			spacing: 30,
			heightDiff: 90,
		};

		initCenterFocusCarousel(
			$container,
			//DESKTOP
			{
				carouselHeight: getTallestHeight,
				activeBasedHeight: true,
				slideConfig,
			},
			//MOBILE
			{
				flickity: {
					cellAlign: getRTL() ? 'right' : 'left',
					contain: false,
				},
			}
		);
	});
}
